module.exports = __webpack_public_path__ + "static/wildlife-new-c0a6bcdf5efcf274ffa9e367ed859a6c.svg";